import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaUser,
  FaShoppingBag,
  FaSearch,
  FaBars,
  FaTimes,
  FaChevronDown,
} from "react-icons/fa";
import "./Navbar.css";
import logo from "../images/Logo192.png";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showPages, setShowPages] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleSearch = () => setSearchActive(!searchActive);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      alert(`Recherche pour : ${searchQuery}`);
      setSearchQuery("");
    }
  };

  const handleUserClick = () => {
    navigate("/register");
  };

  return (
    <header className="navbar-container">
      {/* ------- Bandeau supérieur ------- */}
      <div className="navbar-top">
        <div className="navbar-contact">
          <span>📞 +221 77 638 17 33</span>
          <span>📍 Cité Onomo, Yoff - Dakar, Sénégal</span>
        </div>
        <div className="navbar-social">
          <a href="#">Facebook</a>
          <a href="#">Instagram</a>
          <a href="#">LinkedIn</a>
        </div>
      </div>

      {/* ------- Navbar principale ------- */}
      <nav className="navbar-main">
        {/* Logo */}
        <div className="navbar-logo">
          <Link to="/">
            <img src={logo} alt="logo" />
          </Link>
        </div>

        {/* Menu Burger */}
        <div className="menu-icon" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        {/* ------- Liens ------- */}
        <ul className={`navbar-links ${menuOpen ? "active" : ""}`}>
          <li>
            <Link to="/">Accueil</Link>
          </li>

          {/* ------- Menu déroulant PAGES ------- */}
          <li
            className="navbar-dropdown"
            onClick={() => setShowPages(!showPages)}
          >
            <span className="dropdown-toggle">
              Pages <FaChevronDown style={{ fontSize: "0.7rem" }} />
            </span>

            {showPages && (
              <ul className="dropdown-menu">
                <li>
                  <Link to="/apropos">À propos</Link>
                </li>
                <li>
                  <Link to="/services">Services</Link>
                </li>
                <li>
                  <Link to="/team">Équipe</Link>
                </li>
                <li>
                  <Link to="/faq">FAQ</Link>
                </li>
              </ul>
            )}
          </li>

          <li>
            <Link to="/blog">Blog</Link>
          </li>

          <li>
            <Link to="/shop">Shop</Link>
          </li>

          <li>
            <Link to="/contact">Contact</Link>
          </li>
        </ul>

        {/* ------- Icônes à droite ------- */}
        <div className="navbar-icons">
          {/* Recherche */}
          {searchActive ? (
            <form className="search-form" onSubmit={handleSearch}>
              <input
                type="text"
                placeholder="Rechercher..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button type="submit">
                <FaSearch />
              </button>
            </form>
          ) : (
            <FaSearch className="icon" onClick={toggleSearch} />
          )}

          {/* Utilisateur */}
          <FaUser className="icon" onClick={handleUserClick} />

          {/* Panier */}
          <div className="cart">
            <FaShoppingBag className="icon" />
            <span className="cart-count">2</span>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
